import React from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { config } from '../index';

export interface SpinnerProps {
  /* Spinner size */
  size?: number;
  /* Spinner color */
  fill?: string;
}

const IconWrapper = styled.div<SpinnerProps>`
  position: absolute;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const LogoWrapper = styled.div<SpinnerProps>`
  position: absolute;
  z-index: 98;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5px;
`;

const Icon = styled.svg<SpinnerProps>`
  flex: none;
  transition: ${config.transitionShort};
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  animation: rotating 2s linear infinite; // rotate the spinner
  fill: rebeccapurple;

  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  ${IconWrapper}:hover & {
    fill: rebeccapurple;
  }
`;

export const Spinner: React.FC<SpinnerProps> = ({
  size = 48,
  fill = config.darkMuted,
}) => {
  return (
    <IconWrapper>
      <LogoWrapper>Rentify</LogoWrapper>
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        size={size}
        viewBox="0 0 256 256"
      >
        <line
          x1="128"
          y1="32"
          x2="128"
          y2="64"
          stroke={config.cedarChest}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="195.9"
          y1="60.1"
          x2="173.3"
          y2="82.7"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="224"
          y1="128"
          x2="192"
          y2="128"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="195.9"
          y1="195.9"
          x2="173.3"
          y2="173.3"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="128"
          y1="224"
          x2="128"
          y2="192"
          fill={fill}
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="60.1"
          y1="195.9"
          x2="82.7"
          y2="173.3"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="32"
          y1="128"
          x2="64"
          y2="128"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
        <line
          x1="60.1"
          y1="60.1"
          x2="82.7"
          y2="82.7"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="12"
        />
      </Icon>
    </IconWrapper>
  );
};
